<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ title }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12="xs12" sm4="sm4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line="single-line"
            hide-details="hide-details"
            clearable="clearable"
          >
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left" @click="viewInvoice(props.item)">
              <span>
                <a @click="viewInvoice(props.item)">{{
                  props.item.invoiceID
                }}</a>
              </span>
              <v-chip
                class="ml-1"
                small="small"
                color="#D0E9FF"
                v-if="props.item.hasHardware"
              >
                <v-icon small="small" color="#3C4DA6">keyboard</v-icon>
              </v-chip>
              <v-chip
                class="ml-1"
                small="small"
                dark="dark"
                color="#d2f8d2"
                v-if="props.item.givenDay !== 0"
              >
                <v-icon small="small" color="green">access_time</v-icon>
                <span class="ml-1 green--text">{{ props.item.givenDay }} </span>
              </v-chip>
            </td>
            <td class="text-xs-left">
              {{ $moment(props.item.createDateTime).format("MM/DD/YYYY") }}
            </td>
            <td class="text-xs-left">
              <div>
                <a @click="open(props.item)">{{ props.item.Store.CSPID }}</a>
                <template v-for="data in props.item.Store.ProductRelations">
                  <v-tooltip
                    class="m1-1 pointer"
                    bottom="bottom"
                    v-if="data.isLocked"
                  >
                    <template slot="activator">
                      <v-icon
                        class="ml-2"
                        small="small"
                        color="red"
                        v-if="data.isLocked"
                        >lock</v-icon
                      >
                    </template>
                    <span>{{ data.name }}</span>
                  </v-tooltip>
                  <v-tooltip
                    class="m1-1 pointer"
                    bottom="bottom"
                    v-if="data.serviceID == 192 && data.isCanceled == true"
                  >
                    <template slot="activator">
                      <v-icon
                        class="ml-2"
                        small="small"
                        color="red"
                        v-if="data.serviceID == 192 && data.isCanceled == true"
                        >desktop_access_disabled
                      </v-icon>
                    </template>
                    <span>{{ data.name }}</span>
                  </v-tooltip>
                </template>
                <!-- <v-icon small="small" v-if="props.item.Store.isLocked">lock</v-icon> -->
              </div>
            </td>
            <td class="text-xs-left">{{ props.item.Store.businessName }}</td>
            <td class="text-xs-left">
              {{ $moment(props.item.chargeDateTime).format("MM/DD/YYYY") }}
            </td>
            <td class="text-xs-center" v-if="props.item.collectCounter < 1">
              {{ props.item.collectCounter }}
            </td>
            <td class="text-xs-center" v-else @click="viewInvoice(props.item)">
              <v-chip color="warning" text-color="white" small="small">{{
                props.item.collectCounter
              }}</v-chip>
            </td>
            <td class="text-xs-right">
              {{ props.item.invoiceAmount | currency }}
            </td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left" offset-y="offset-y">
                <v-btn slot="activator" icon="icon">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list class="menu-button">
                  <Payment
                    :invoice="props.item"
                    @save="save"
                    @refresh="$emit('reloadList')"
                  >
                  </Payment>
                  <v-list-tile @click="open(props.item)">
                    <v-list-tile-title>{{
                      $t("buttons.openStorePage")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider> </v-divider>
                  <v-list-tile @click="viewInvoice(props.item)">
                    <v-list-tile-title
                      >{{ $t("buttons.view") }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import invoiceService from "../service.js";
import { mapGetters } from "vuex";
const Payment = () => import("./Payment");

export default {
  props: ["title", "items", "loading", "order", "invoiceEmail"],
  data() {
    const value = {
      paymentDialog: false,
      selectedInvoice: null,
      headers: [
        {
          text: this.$t("labels.invoiceNumber"),
          value: "invoiceID",
          sortable: true,
          width: "10%",
        },
        {
          text: this.$t("labels.createdAt"),
          value: "createDateTime",
          sortable: true,
          width: "10%",
        },
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
          width: "10%",
        },
        {
          text: this.$t("labels.businessName"),
          value: "Store.businessName",
          sortable: true,
        },
        {
          text: this.$t("labels.chargeDate"),
          value: "chargeDateTime",
          width: "10%",
          sortable: true,
        },
        {
          text: this.$t("labels.collectCount"),
          value: "collectCounter",
          sortable: true,
        },
        {
          text: this.$t("labels.invoiceAmount"),
          value: "invoiceAmount",
          width: '10%',
          sortable: true,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "chargeDateTime",
        descending: false,
      },
    };
    return value;
  },
  computed: {
    ...mapGetters("location", ["location"]),
  },
  components: {
    Payment,
  },
  methods: {
    save() {
      this.$emit("reloadList");
    },
    open(data) {
      this.$router.push({ path: `/location/profile/${data.Store.storeID}` });
    },
    viewInvoice(data) {
      // this.$router.push({path: `/global/invoice/${data.invoiceID}/view`});
      const routeData = this.$router.resolve({
        path: `/global/invoice/${data.invoiceID}/view`,
      });
      window.open(routeData.href, "newwindow", "width=800, height=950");
    },
  },
};
</script>

<style scoped></style>
